import { render, staticRenderFns } from "./IdcEditAndActionContract.vue?vue&type=template&id=4a773808&scoped=true&"
import script from "./IdcEditAndActionContract.vue?vue&type=script&lang=js&"
export * from "./IdcEditAndActionContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a773808",
  null
  
)

export default component.exports